import { ClickAndReserve } from "./feature-config.enum.js";
function assertClickAndReserveFeatureConfig(value) {
  if (value && !(value in ClickAndReserve)) {
    throw new Error(
      "environment variable `FEATURE_CONFIGURATION_CLICK_AND_RESERVE` does not contain a valid value"
    );
  }
}
const getClickAndReserveFeatureConfig = (value) => {
  assertClickAndReserveFeatureConfig(value);
  return value;
};
export {
  getClickAndReserveFeatureConfig
};
//# sourceMappingURL=utils.js.map
